import React from 'react';
import styled from '../../node_modules/styled-components';

export function Link(props) {
  return <A href={props.to}>{props.children}</A>;
}

const A = styled.a`
  text-decoration: none;
  width: 100%;
  cursor: pointer;
`;

export default Link;



// WEBPACK FOOTER //
// ./src/components_new/Link.js